import { Observable } from 'rxjs';
import { MessengerMessage } from '../interfaces/messenger.interface';

export abstract class MessengerService {
  public abstract get messengerChanges(): Observable<MessengerMessage[]>;

  public abstract get messengerChannelConnectionStateChanged(): Observable<boolean>;
}
